export const SETTINGS_KEYS = [
  "timezone",
  "address",
  "repo_th",
  "similarity_addition",
  "valid_th_from",
  "valid_th_to",
  "ppe_types",
  "ppe_min_confidence",
  "shifts_enabled",
  "shift_auto_detect",
  "payroll_enabled",
] as const;

export type SettingKey = typeof SETTINGS_KEYS[number];

export const SETTING_LABELS: Record<SettingKey, string> = {
  timezone: "Timezone",
  address: "Address",
  repo_th: "Repository Threshold",
  similarity_addition: "Similarity Addition",
  valid_th_from: "Valid Threshold From",
  valid_th_to: "Valid Threshold To",
  ppe_types: "PPE Types",
  ppe_min_confidence: "PPE Min Confidence",
  shifts_enabled: "Shift Scheduling",
  shift_auto_detect: "Auto-detect Shift",
  payroll_enabled: "Payroll",
};

export const DEFAULT_SETTINGS_VALUES = {
  repo_th: 0,
  similarity_addition: 0,
  valid_th_from: 0,
  valid_th_to: 0,
  ppe_types: [] as string[],
  ppe_min_confidence: 0.8,
  shifts_enabled: false,
  shift_auto_detect: false,
  payroll_enabled: false,
} as const;